import { atom, useAtom } from "jotai";

const contentBlockWithAddButtonClickedIdAtom = atom<string | false>(false);
contentBlockWithAddButtonClickedIdAtom.debugLabel =
    "contentBlockWithAddButtonClickedIdAtom";
    
export function useIsAddingContentBlock(contentBlockId: string = "") {
    const [contentBlockWithAddButtonClickedId, setIsAddingBlock] = useAtom(
        contentBlockWithAddButtonClickedIdAtom,
    );

    return {
        isAddingContentBlock:
            contentBlockWithAddButtonClickedId === contentBlockId,
        setIsAddingBlock,
        isAddingAnyContentBlock: contentBlockWithAddButtonClickedId !== false,
        contentBlockWithAddButtonClickedId,
    };
}
